<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Accusé de reception du technicien</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <!--        <label class="mt-4 block text-gray-700">Envoyer au superviseur:</label>-->
        <select v-model="form.sent" class="mt-1 w-full form-select">
          <option :value="null"/>
          <!--          <option value="with">Envoyer et non envoyer</option>
                    <option value="only">Envoyer uniquement</option>-->
        </select>
      </search-filter>

    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">N° Order</th>
          <th class="px-6 pt-6 pb-4">IMEI</th>
          <th class="px-6 pt-6 pb-4">Modele</th>
          <th class="px-6 pt-6 pb-4">Operateur</th>
          <th class="px-6 pt-6 pb-4">Agence</th>
          <th class="px-6 pt-6 pb-4">Panne</th>
          <th class="px-6 pt-6 pb-4">Affectation</th>
          <th class="px-6 pt-6 pb-4">Accusé</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Creation</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer">
          <td class="border-t" @click="showForm(repair)">
            <span class="px-6 py-4 flex items-center focus:text-indigo-500">
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.imei }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.model }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.operator }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.agency }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.malfunction }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.assignedTo }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.receivedBy }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-6 py-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              {{ repair.created_at }}
            </span>
          </td>
          <td class="border-t w-px" @click="showForm(repair)">
            <span class="px-4 flex items-center" :href="route('receptions.edit', repair.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </span>
          </td>
        </tr>
        <tr v-if="repairs.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No reception found.</td>
        </tr>
      </table>
      <!-- Detail Modal -->
      <jet-dialog-modal max-width="2xl" :show="detailForm" :closeable="false" @close="detailForm = false">
        <template #title>
          Re-assigner le poste
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">
              <select-input v-model="selectedUser" :error="errors.selectedUser" class="pr-6 w-60" label="Techniciens">
                <option disabled></option>
                <option v-for="tech in techs" :key="tech.id" :value="tech.id" >{{tech.name}}</option>
              </select-input>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green" @click.native="reAssign()"
                      :class="{ 'opacity-25': processing }" :disabled="processing">
            Affecter
          </jet-button>
        </template>
      </jet-dialog-modal>
    </div>
    <pagination :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from "@/Shared/TextInput";
import SelectInput from '@/Shared/SelectInput'
import JetButton from '@/Jetstream/Button'
import JetDialogModal from '@/Jetstream/DialogModal'


export default {
  metaInfo: {title: 'Accusé de reception du technicien'},
  layout: Layout,
  components: {
    TextInput,
    Icon,
    SearchFilter,
    Pagination,
    LoadingButton,
    SelectInput,
    JetButton,
    JetDialogModal
  },
  props: {
    errors: Object,
    repairs: Object,
    filters: Object,
    techs: Object,
  },
  data() {
    return {
      processing: false,
      detailForm: false,
      selectedItem: null,
      selectedUser: null,
      selectAll: false,
      sending: false,
      form: {
        search: this.filters.search,
        role: this.filters.role,
        sent: this.filters.sent,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('supervisor.techReceived', Object.keys(query).length ? query : {remember: 'forget'}), {
          preserveScroll: true,
          preserveState: true,
        })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    showForm(repair) {
      this.selectedItem = repair.id
      this.detailForm = true
    },
    reAssign() {
      const data = new FormData()
      data.append('id', this.selectedItem || '')
      data.append('user', this.selectedUser || '')
      this.$inertia.post(this.route('supervisor.reassign'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
          this.selectedItems = []
        },
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {
            this.detailForm = false
            this.selectedItem = null
          }
        },
      })
    }
  },
}
</script>
